<template>
  <div class="row">
    <div :class="!items.length ? 'col-md-12' : 'col-md-8 pr30-md'">
      <loader :loading="loading"></loader>
      <div class="card">
        <cart-list-item
          :item="item"
          v-for="(item, index) in items"
          :key="index"
        />

        <div
          v-if="!items.length"
          class="align-items-center d-flex flex-column justify-content-center my30-md my20"
        >
          <div
            class="cart-empty bb-lightgray bt-lightgray mb20 p20 text-center"
          >
            There are no items in your cart
          </div>
          <div class="main-btn py10 px0">
            <a href="/">
              Continue Shopping
            </a>
          </div>
        </div>

        <div
          class="my20-md my10"
          v-if="items.length && noticeBlock"
          v-html="noticeBlock.content"
        ></div>
      </div>
    </div>

    <ValidationObserver
      ref="formObserver"
      v-slot="{ invalid, errors }"
      tag="form"
      class="col-md-4 py20 pl30-md cart-sidemenu"
      v-if="items.length"
      @submit.prevent="onSubmit"
    >
      <ValidationProvider ref="cartCount" rules="min:1" name="Cart" slim>
        <input
          type="hidden"
          name="term_and_conditions"
          v-model="items.length"
        />
      </ValidationProvider>

      <h2 class="fs14 fs16-md fs20-lg ff-nunito-bold mt0 mb20-md mb10">
        Subtotal: {{ totalPrice | moneyToCurrencyFormat }}
      </h2>

      <div class="form-group mb20-md mb10">
        <label for="order-notes" class="ff-nunito-bold mb10">
          Order Notes
        </label>
        <textarea
          id="order-notes"
          class="form-control"
          name=""
          rows="3"
          style="resize: none;"
          v-model="instructions"
        />
      </div>

      <ValidationProvider
        rules="required:true"
        name="Terms & Conditions"
        tag="div"
        class="form-check custom__checkbox mb20-md mb10"
      >
        <input
          id="terms-and-conditions"
          class="form-check-input"
          type="checkbox"
          name="term_and_conditions"
          v-model="termsAndConditions"
        />
        <label for="terms-and-conditions" class="form-check-label">
          I agree with all the
          <a href="/terms-and-conditions" class="main-link ml-1">
            Terms &amp; Conditions
          </a>
        </label>
      </ValidationProvider>

      <p class="block-block-terms mb20-md mb10">
        Please double check all order information before proceeding to check
        out. Wert Philippines, Inc. will not be liable for any wrong delivery
        information entered. If you input the wrong address or contact details,
        please contact the courier directly for assistance.
      </p>

      <div v-if="invalid" class="my20-md my10 text-danger">
        <p v-for="(error, key) in Object.values(errors).flat()" :key="key">
          {{ error }}
        </p>
      </div>

      <div class="action-btns">
        <div class="main-btn p0 mb20-md mb10">
          <button type="submit">
            Checkout
          </button>
        </div>
        <div class="main-btn secondary-btn py10 px0">
          <a href="/shop">
            Continue Shopping
          </a>
        </div>
      </div>
    </ValidationObserver>
  </div>
</template>

<script>
import CartListItem from "../components/cart/CartListItem";
import Loader from "../components/Loader";
import { ValidationObserver, ValidationProvider } from "vee-validate";
import { mapStateWithMutation } from "../helpers/vuexHelpers";
import block from "../api/block";

export default {
  components: {
    CartListItem,
    Loader,
    ValidationObserver,
    ValidationProvider
  },
  data() {
    return {
      termsAndConditions: false,
      noticeBlock: null
    };
  },
  computed: {
    loading() {
      return this.$store.state.cart.loading;
    },
    items() {
      return this.$store.state.cart.items;
    },
    totalPrice() {
      return this.$store.state.cart.totalPrice;
    },
    ...mapStateWithMutation("checkout", {
      instructions: {
        state: state => state.instructions,
        mutation: "UPDATE_INSTRUCTIONS"
      }
    })
  },
  async created() {
    this.$validator.localize("en", {
      custom: {
        "Terms & Conditions": {
          required: "Please accept the Terms & Conditions first"
        }
      }
    });

    const {
      data: { block_data = null }
    } = await block.get("bag-notice");

    this.noticeBlock = block_data;
  },
  methods: {
    async onSubmit(event) {
      const isValid = await this.$refs.formObserver.validate();

      if (!isValid) {
        return;
      }

      if (this.items.length <= 0) {
        this.$refs.cartCount.applyResult({
          errors: ["Please add and item first"],
          valid: false
        });

        return;
      }

      this.$store.commit("checkout/UPDATE_STEP_COMPLETED", "cart");

      this.$router.push({ name: "information" });
    }
  }
};
</script>

<style></style>
